import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const VerticalMenu = ({
  size,
  type,
  theme,
  className,
  dataTestId = "vertical-menu-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M9.47617 2.51256C9.47617 3.32793 8.81518 3.98893 7.9998 3.98893C7.18443 3.98893 6.52344 3.32793 6.52344 2.51256C6.52344 1.69719 7.18443 1.03619 7.9998 1.03619C8.81518 1.03619 9.47617 1.69719 9.47617 2.51256Z" />
    <path d="M9.47617 7.9996C9.47617 8.81498 8.81518 9.47597 7.9998 9.47597C7.18443 9.47597 6.52344 8.81498 6.52344 7.9996C6.52344 7.18423 7.18443 6.52324 7.9998 6.52324C8.81518 6.52324 9.47617 7.18423 9.47617 7.9996Z" />
    <path d="M7.9998 14.9629C8.81518 14.9629 9.47617 14.3019 9.47617 13.4865C9.47617 12.6711 8.81518 12.0102 7.9998 12.0102C7.18443 12.0102 6.52344 12.6711 6.52344 13.4865C6.52344 14.3019 7.18443 14.9629 7.9998 14.9629Z" />
  </SVGIcon>
);
